import React from 'react';

import { SocialMedias } from './SocialMedias';
import { NavigationMenu } from './NavigationMenu';
import { SupportMenu } from './SupportMenu';
import { PagarmeMenu } from './PagarmeMenu';
import { ContactMenu } from './ContactMenu';
import { StoneCompanies } from './StoneCompanies';

import * as S from './styles';

const Footer = () => (
  <S.FooterLayout>
    <S.FooterContainer>
      <S.MainFooterWrapper>
        <SocialMedias />

        <S.FooterGrid>
          <S.FooterGridItem>
            <NavigationMenu />
          </S.FooterGridItem>

          <S.FooterGridItem>
            <SupportMenu />
          </S.FooterGridItem>

          <S.FooterGridItem>
            <PagarmeMenu />
          </S.FooterGridItem>

          <S.FooterGridItem>
            <ContactMenu />
          </S.FooterGridItem>
        </S.FooterGrid>
      </S.MainFooterWrapper>

      <StoneCompanies />
    </S.FooterContainer>
  </S.FooterLayout>
);

export default Footer;
